export const cellInputMapper = {
  "시간" : 'PPTIME',
  "SPEED" : 'SPEEDX' ,
  "실평량" : 'SBSSWG' ,
  "수분" : 'WATERX' ,
  "두께" : 'THICKX' , 
  // "밀도" : 'MILDOX' ,
  "MD 압강" : 'MDABGA' ,
  "CD 압강" : 'CDABGA' ,
  // "CD Index" : 'CDINDX' ,
  "MD/CD" : 'MDCDXX' ,
  "파강" : 'PAGANG' ,
  // "파강 Index" : 'PAINDX' ,
  "색상 L" : 'COLORL' ,
  "색상 A" : 'COLORA' ,
  "색상 B" : 'COLORB' ,
  "Cobb size" : 'COBBSI' ,
  "Cobb 온도" : 'COBBTE' ,
  "Cobb 습도" : 'COBBDE' ,
 }
export const shncodToRcodex = {
  65 : "AF",
  93 : "AOC",
  11 : "AS",
  60 : "AT",
  20 : "B",
  72 : "CS",
  92 : "DK",
  80 : "HK",
  70 : "JK",
  71 : "JKW",
  41 : "K",
  40 : "K2",
  45 : "KLB",
  94 : "KOC",
  13 : "M1",
  30 : "QK",
  10 : "S",
  44 : "SK",
  43 : "SK",
  42 : "SKY",
  47 : "SK",
  46 : "SKY",
  99 : "공통",
  90 : "수출지",
}